import { memo, PropsWithChildren } from 'react';
import { useTranslation } from '@betty/i18n';
import styles from './Page.module.css';
import { PageProps } from './Page.types';

function Page({
  title: titleProp,
  titleKey = 'seoTitle',
  titleNS = 'common',
  description: descriptionProp,
  descriptionKey = 'seoDescription',
  descriptionNS = 'common',
  children,
}: PropsWithChildren<PageProps>) {
  const [titleT] = useTranslation(titleNS);
  const [descriptionT] = useTranslation(descriptionNS);
  const title = titleProp || titleT(titleKey);
  const description = descriptionProp || descriptionT(descriptionKey);

  return (
    <div className={`${styles.page}`}>
      {title ? (
        <>
          <title>{title}</title>
          <meta property="og:title" content={title} />
        </>
      ) : null}
      {descriptionKey ? (
        <>
          <meta name="description" content={description} />
          <meta property="og:description" content={description} />
        </>
      ) : null}
      {children}
    </div>
  );
}

export default memo(Page);
